module.exports = __webpack_public_path__ + "static/media/stripe-create-account_7.3593e47f.png";